import { useCallback } from "react";

import { useMutationWithToaster } from "hooks";

export function useDeleteMeeting(onDone) {
  const mutationFactory = useCallback(() => {
    const query = `
        mutation deleteEvent($id: ID!) {
            deleteEvent(id: $id) {
                successMessage
            }
        }`;

    const resolver = (resp) => {
      return resp;
    };

    return { query, resolver };
  }, []);

  const [deleteMeetingMutation, { loading }] = useMutationWithToaster(
    mutationFactory,
    { onDone }
  );

  return {
    isDeleting: loading,
    delete: async ({ id, name }) => {
      return deleteMeetingMutation(
        { id },
        {
          successMsg: `Successfully deleted meeting ${name}.`,
          defaultErrorMsg:
            "Failed to delete meeting. Please retry or contact support for assistance.",
        }
      );
    },
  };
}

export default useDeleteMeeting;
